import { Fragment, useEffect } from 'react'
import { Link } from 'gatsby'
import RootElement from './src/components/RootElement'
import { DistinctIDStoreUpdater, distinctIdStore } from './src/store/Store'

import './src/fonts/DomaineText-Light.ttf'
import './src/fonts/DomaineText-Regular.ttf'
import './src/fonts/PPObjectSans-Regular.ttf'
import './src/fonts/PPObjectSans-Heavy.ttf'
import './src/styles/main.css'
import CookieConsent, { getCookieConsentValue } from 'react-cookie-consent'
import { useLocation } from '@reach/router' // this helps tracking the location
import { initializeAndTrack } from '@mobile-reality/gatsby-plugin-gdpr-cookies'
import {
  cookiePrivacyLinkEN,
  cookiePrivacyLinkES,
} from './src/utils/navigationLinks'

interface HotjarWindow extends Window {
  hj?: any
  _hjSettings?: any
}

const HotjarScript = () => {
  useEffect(() => {
    const hotjar = (h: HotjarWindow, doc: Document) => {
      h.hj =
        h.hj ||
        function () {
          ;(h.hj.q = h.hj.q || []).push(arguments)
        }
      h._hjSettings = { hjid: 4933567, hjsv: 6 }
      const headElement = doc.getElementsByTagName('head')[0]
      const scriptElement = doc.createElement('script')
      scriptElement.async = true
      scriptElement.src = `https://static.hotjar.com/c/hotjar-${h._hjSettings.hjid}.js?sv=${h._hjSettings.hjsv}`
      headElement.appendChild(scriptElement)
    }
    hotjar(window, document)
  })

  return <Fragment />
}

const HubspotScript = () => {
  useEffect(() => {
    const hubspot = (doc: Document) => {
      const bodyElement = doc.getElementsByTagName('body')[0]
      const scriptElement = doc.createElement('script')
      scriptElement.async = true
      scriptElement.id = 'hs-script-loader'
      scriptElement.type = 'text/javascript'
      scriptElement.src = 'https://js.hs-scripts.com/39610279.js'
      bodyElement.appendChild(scriptElement)
    }
    hubspot(document)
  })

  return <Fragment />
}

export const wrapPageElement = ({ element, props }) => {
  const trackingCookie = getCookieConsentValue('gatsby-gdpr-google-analytics')
  const location = useLocation()

  const spanish = location.pathname.startsWith('/es/')

  const iUnderstandLabel = !spanish ? 'I understand' : 'Lo entiendo'
  const iDeclineLabel = !spanish ? 'I decline' : 'Rechazar'

  const cookieBannerText = !spanish
    ? 'This website uses cookies essential to delivering our service and enhancing the user experience. Review our Privacy Policy'
    : 'Este sitio web utiliza cookies esenciales para la prestación de nuestros servicios y la mejora de la experiencia del usuario. Por favor, revise nuestra Política de Privacidad'

  const cookiePrivacyLink = !spanish ? cookiePrivacyLinkEN : cookiePrivacyLinkES
  return (
    <Fragment>
      {/* <HotjarScript /> */}
      {trackingCookie === 'true' && <HotjarScript />}
      {trackingCookie === 'true' && <HubspotScript />}

      <DistinctIDStoreUpdater
        store={distinctIdStore}
        location={props.location}
      />
      {element}
      <CookieConsent
        enableDeclineButton={true}
        location="bottom"
        buttonText={iUnderstandLabel}
        declineButtonText={iDeclineLabel}
        cookieName="gatsby-gdpr-google-analytics"
        style={{
          background: '#EEE8DA',
          fontFamily: '"Domaine Text", serif;',
          color: '#000000',
        }}
        buttonStyle={{
          background: '#19179c',
          color: '#ffffff',
          fontWeight: 'bold',
          fontSize: '13px',
          fontFamily: 'PP Object Sans, sans-serif',
          textTransform: 'uppercase',
        }}
        declineButtonStyle={{
          background: '#EEE8DA',
          color: '#000',
          fontWeight: 'bold',
          fontSize: '13px',
          fontFamily: 'PP Object Sans, sans-serif',
          textTransform: 'uppercase',
        }}
        expires={150}
        onAccept={() => {
          initializeAndTrack(location)
        }}
      >
        {cookieBannerText}{' '}
        <Link to={cookiePrivacyLink.href} tw="mb-0 lg:(mb-[10px] inline-block)">
          <span style={{ textDecoration: 'underline' }}>
            {cookiePrivacyLink.label}
          </span>
          .
        </Link>
      </CookieConsent>
    </Fragment>
  )
}

export const wrapRootElement = ({ element }) => {
  return <RootElement>{element}</RootElement>
}
